import { AmountWithUnit, AmountWithUnitSkeleton } from 'components/shared/Amount/Amount';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { useExistsValidationErrorFor } from '../ValidationErrorsContext';

interface OwnProps {
  notional?: number;
  currency?: string;
  visible: boolean;
  onChange: (newNotional: number | undefined) => void;
}
export const AddonNotional: FC<OwnProps> = ({ notional, currency, visible, onChange }) => {
  const intl = useIntl();
  const hasError = useExistsValidationErrorFor('addonNotional');
  const { isReadOnly, isLoading } = useContext(AddonMainFormContext);

  if (!visible) {
    return null;
  }

  return (
    <BlockOrientationFormGroup inputId="addonNotional" label="addon.notional">
      {!isLoading && (
        <AmountWithUnit
          isDisabled={isReadOnly}
          e2e="addon-investment-details-notional"
          id="addonNotional"
          placeholder={intl.formatMessage({ id: 'addon.notional' })}
          unit={currency}
          value={notional}
          onChange={onChange}
          hasError={hasError}
        />
      )}
      {isLoading && <AmountWithUnitSkeleton unit={currency} />}
    </BlockOrientationFormGroup>
  );
};

AddonNotional.displayName = 'AddonNotional';
